import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './MarigoldPage.css';
import marigoldLogo from '../images/marigold-logo.png';
import marigoldOrangeQueen from '../images/marigold-Orange-Queen-img.png';
import marigoldYellow from '../images/marigold-yellow-img.png';

const varieties = [

 
  {
    name: 'ORANGE QUEEN',
    image: marigoldOrangeQueen,
    description: [
      'Category: Marigold',
      'Plant type: Medium tall, strong and vigorous',
      'Days to first plucking: 60-65 DAT',
      'Flower colour: Orange',
      'Flower type: Compact',
      'Flower diameter: 7.5-8 cm',
      'Flower weight: 12-15 gm',
      'Remark: Compact and uniform size flowers with high yielding capacity',
    ],
  },
  {
    name: 'DYNASTY YELLOW',
    image: marigoldYellow,
    description: [
      'Category: Marigold',
      'Plant type: Dwarf bushy and vigorous',
      'Days to first plucking: 55-60 DAT',
      'Flower colour: Lemon yellow',
      'Flower type: Very compact',
      'Flower diameter: 6.5-7 cm',
      'Flower weight: 8-10 gm',
      'Remark: Bushy plants with good yielding capacity',
    ],
  },
];

export default function MarigoldPage() {
  return <ProductPatternPage title="Marigold" varieties={varieties} pageClass="marigold-page" heroImage={marigoldLogo} />;
}
